module.exports = __webpack_public_path__ + "img/rain.f8c2a3a4.png";